<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">انواع العقارات</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">انواع العقارات</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="checkAccess('property_types_create')" class="row">
          <div class="col text-end">
            <router-link to="/typecreate" class="btn btn-primary">
              <i class="bi bi-plus-circle ms-1"></i> إضافة نوع عقار
            </router-link>
          </div>
        </div>

        <div v-if="isLoading" class="text-center">
          <mainLoader />
        </div>
        <div class="text-center pt-3 " v-if="hasError">
          <errorAlert :alertMessage="message"  />
        </div>
        <div v-if="!isLoading" class="row justify-content-center overflow-auto mb-4 mt-5">
          <div class="col-12 col-md-11 pe-5">
            <table class="table table-striped table-hover text-center">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <!-- <th scope="col">الصورة</th> -->
                  <th scope="col">الاسم</th>
                  <th scope="col">الاسم - انجليزي</th>
                  <th scope="col">الحاله</th>
                  <th scope="col">اخر تحديث</th>
                  <th scope="col">التعديل</th>
                  <th v-if="checkAccess('property_types_delete')" scope="col">الحذف</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in rows" :key="index">
                  <td class="counter"></td>
                  <!-- <td>
                    <img :src="MEDIA_URL+row.icon" class="w-25" alt="">
                  </td> -->
                  <td>{{ row.name }}</td>
                  <td>{{ row.nameEn }}</td>
                  <td>{{ (row.isActive)? 'نشط' : 'غير نشط' }}</td>
                  <td>{{ $shortDate(row.updatedAt) }}</td>
                  <td>
                    <router-link v-if="checkAccess('property_types_update')" :to="'/typeupdate/'+row.id">
                      <i class="bi bi-card-list"></i>
                    </router-link>
                    <router-link v-else :to="'/typeRead/'+row.id">
                      <i class="fa-regular fa-eye"></i>
                    </router-link>
                  </td>
                  <td v-if="checkAccess('property_types_delete')">
                    <a @click.prevent="deleteItem(index, row.id)">
                      <i class="bi bi-archive text-red pointer-mouse"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import { toast, checkAccess } from '@/helpers/tools';
export default {
  name: "typeview",
  data(){
    return{
      hasError: false,
      message: "",
      isLoading: false,
      rows: [],
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  methods: {
    checkAccess, 
    getData(){
      this.isLoading = true;
      this.$http.get('/api/admin/propertyTypes/list').then(res => {
        // console.log(res);
        this.isLoading = false;
        this.rows = res.data.propertyTypes;
      }).catch (err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.hasError = true;
        window.scroll(0,0);
        this.isLoading = false;
      });
    },
    deleteItem(index, id) {
      this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.delete(`/api/admin/propertyTypes/delete/${id}`).then(({data}) => {
            this.rows.splice(index, 1);
            toast('تم حذف السجل بنجاح', 'success');
          }).catch(err => {
            toast('غير قادر على حذف السجل');
          });
        }
      });
    },
  },
  created(){
    this.getData();
  }
}
</script>